import { BASE_URLS, axiosInstance } from "@/src/shared/api";
import {
    CreateNextNavigationPropsType,
    CreatePreviousNavigationPropsType,
    ProcessInstanceType,
} from "@/src/shared/schemas";

export const createNextNavigation = async (
    body: CreateNextNavigationPropsType,
): Promise<ProcessInstanceType> => {
    try {
        const response = await axiosInstance.post(`${BASE_URLS.NAVIGATION_NEXT}`, body);
        return response.data;
    } catch (error: any) {
        console.log("error", "Error while creating next navigation",  {
            url: error?.config?.url,
            meta: error?.response?.data,
        })
        throw error
    }
};

export const createPreviousNavigation = async (
    body: CreatePreviousNavigationPropsType,
): Promise<ProcessInstanceType> => {
    try {
        const response = await axiosInstance.post(`${BASE_URLS.NAVIGATION_PREV}`, body);
        return response.data;
    } catch (error: any) {
        console.log("error", "Error while creating prev navigation",  {
            url: error?.config?.url,
            meta: error?.response?.data,
        })
        throw error;
    }
};

export const createSpecificStepNavigation = async ({
    code,
    body,
}: {
    code: string;
    body: {
        processInstanceId: string;
        contextVariablesToUpdate: any[];
        timeSpent: number;
        navigationType: "NEXT" | "PREVIOUS";
    };
}): Promise<ProcessInstanceType> => {
    try {
        const response = await axiosInstance.post(
            `${BASE_URLS.NAVIGATION_SPECIFIC_STEP_CODE}/${code}`,
            body
        );
        return response.data;
    } catch (error: any) {
        console.log("error", "Error while creating specific step navigation",  {
            url: error?.config?.url,
            meta: error?.response?.data,
        })
        throw error;
    }
}

